/* Foreshank PDP — foreshank-pdp.js
   Requires window.FH_VARIANTS (injected by section as JSON) */
(function () {
  'use strict';

  var THRESHOLD     = 4000;
  var GWP_ENABLED   = window.FH_GWP_ENABLED   || false;
  var GWP_THRESHOLD = window.FH_GWP_THRESHOLD  || 4500;

  /* ── State ──────────────────────────────────────────────────── */
  var selectedPackSize = null;
  var selectedGrade    = null;

  /* ── DOM refs ───────────────────────────────────────────────── */
  var variantInput      = document.getElementById('fh-variant-input');
  var priceEl           = document.getElementById('fh-price');
  var perBallEl         = document.getElementById('fh-per-ball');
  var shippingMsg       = document.getElementById('fh-shipping-msg');
  var shippingSub       = document.getElementById('fh-shipping-sub');
  var shippingTrack     = document.getElementById('fh-shipping-track');
  var configSummaryEl   = document.getElementById('fh-config-summary');
  var shippingMilestone = document.getElementById('fh-shipping-milestone');
  var gwpMilestone      = document.getElementById('fh-gwp-milestone');
  var atcPriceEl        = document.getElementById('fh-atc-price');
  var stickyEl          = document.getElementById('fh-sticky');
  var stickyPack        = document.getElementById('fh-sticky-pack');
  var stickyPrice       = document.getElementById('fh-sticky-price');
  var stickyBtn         = document.getElementById('fh-sticky-btn');
  var packCards         = document.querySelectorAll('.fh-pack');
  var gradeBtns         = document.querySelectorAll('.fh-grade-btn');
  var galleryTrack      = document.getElementById('fh-gallery-track');
  var galleryDots       = document.querySelectorAll('.fh-gallery__dot');
  var galleryThumbs     = document.querySelectorAll('.fh-gallery__thumb');
  var form              = document.getElementById('fh-atc-form');
  var qtyInput          = document.getElementById('fh-qty-input');

  /* ── Helpers ────────────────────────────────────────────────── */
  function formatMoney(pence) {
    return '£' + (pence / 100).toFixed(2).replace(/\.00$/, '');
  }

  function findVariant(packSize, grade) {
    var variants = window.FH_VARIANTS || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].option1 === packSize && variants[i].option2 === grade) {
        return variants[i];
      }
    }
    return null;
  }

  /* ── Extract ball count from option string ───────────────────── */
  function ballCountFromPackSize(packSize) {
    var parts = packSize.split(' ');
    var n = parseInt(parts[2], 10);
    return isNaN(n) ? 12 : n;
  }

  /* ── Mark sold-out pack cards and grade buttons ─────────────── */
  function updateAvailability(packSize, grade) {
    var variants = window.FH_VARIANTS || [];

    /* Grade buttons: unavailable if selected pack + that grade has no stock */
    gradeBtns.forEach(function (btn) {
      var g = btn.dataset.grade;
      var avail = false;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === packSize && variants[i].option2 === g && variants[i].available) {
          avail = true;
          break;
        }
      }
      btn.classList.toggle('is-unavailable', !avail);
      btn.disabled = !avail;
    });

    /* Pack cards: unavailable if that pack + selected grade has no stock */
    packCards.forEach(function (card) {
      var p = card.dataset.packSize;
      var avail = false;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === p && variants[i].option2 === grade && variants[i].available) {
          avail = true;
          break;
        }
      }
      card.classList.toggle('is-unavailable', !avail);
    });
  }

  /* ── Update all UI when a new variant is confirmed ───────────── */
  function applyVariant(variant, packSize, grade) {
    if (!variant) return;
    var price      = variant.price;
    var priceFmt   = formatMoney(price);
    var ballCount  = ballCountFromPackSize(packSize);
    var perBall    = Math.round(price / ballCount);

    /* Form */
    if (variantInput) variantInput.value = variant.id;

    /* Price + per ball */
    if (priceEl)    priceEl.textContent    = priceFmt;
    if (perBallEl)  perBallEl.textContent  = formatMoney(perBall) + '/ball';
    if (atcPriceEl) atcPriceEl.textContent = priceFmt;

    /* Shipping bar */
    updateShipping(price);

    /* Sold-out states */
    updateAvailability(packSize, grade);

    /* Config summary (mobile, below price) */
    if (configSummaryEl) configSummaryEl.textContent = packSize + ' · ' + grade;

    /* Sticky */
    if (stickyPack)  stickyPack.textContent  = packSize + ' · ' + grade;
    if (stickyPrice) stickyPrice.textContent = priceFmt;
  }

  /* ── Shipping bar ───────────────────────────────────────────── */
  function updateShipping(pricePence) {
    if (!shippingTrack) return;
    var pct;
    if (GWP_ENABLED) {
      if (pricePence >= GWP_THRESHOLD) {
        pct = 97;
      } else if (pricePence >= THRESHOLD) {
        pct = 75 + Math.round((pricePence - THRESHOLD) * 22 / (GWP_THRESHOLD - THRESHOLD));
      } else {
        pct = Math.round(pricePence * 75 / THRESHOLD);
      }
    } else {
      pct = pricePence >= THRESHOLD ? 90 : Math.round(pricePence * 75 / THRESHOLD);
    }
    shippingTrack.style.backgroundSize = pct + '% 100%';

    if (GWP_ENABLED) {
      if (pricePence >= GWP_THRESHOLD) {
        if (shippingMsg) shippingMsg.innerHTML = 'Free delivery + free golf glove included ✓';
        if (shippingSub) shippingSub.textContent = 'Both included when you check out with this pack';
        if (shippingMilestone) shippingMilestone.classList.add('is-met');
        if (gwpMilestone)      gwpMilestone.classList.add('is-met');
      } else if (pricePence >= THRESHOLD) {
        var gwpRemaining = GWP_THRESHOLD - pricePence;
        if (shippingMsg) shippingMsg.innerHTML = 'Free delivery included ✓ · add <strong>' + formatMoney(gwpRemaining) + '</strong> for a free glove';
        if (shippingSub) shippingSub.textContent = 'Upgrade to Pack of 40 to unlock the free glove';
        if (shippingMilestone) shippingMilestone.classList.add('is-met');
        if (gwpMilestone)      gwpMilestone.classList.remove('is-met');
      } else {
        var remaining = THRESHOLD - pricePence;
        if (shippingMsg) shippingMsg.innerHTML = 'You\'re <strong>' + formatMoney(remaining) + '</strong> away from free delivery';
        if (shippingSub) shippingSub.textContent = 'Upgrade to Pack of 40 for free shipping + a free golf glove';
        if (shippingMilestone) shippingMilestone.classList.remove('is-met');
        if (gwpMilestone)      gwpMilestone.classList.remove('is-met');
      }
    } else {
      if (pricePence >= THRESHOLD) {
        if (shippingMsg) shippingMsg.innerHTML = 'Free delivery included ✓';
        if (shippingSub) shippingSub.textContent = 'Your order qualifies for free shipping';
        if (shippingMilestone) shippingMilestone.classList.add('is-met');
      } else {
        var remaining2 = THRESHOLD - pricePence;
        if (shippingMsg) shippingMsg.innerHTML = 'You\'re <strong>' + formatMoney(remaining2) + '</strong> away from free delivery';
        if (shippingSub) shippingSub.textContent = 'Upgrade to Pack of 40 and get free shipping';
        if (shippingMilestone) shippingMilestone.classList.remove('is-met');
      }
    }
  }

  /* ── Update pack card prices when grade changes ─────────────── */
  function updatePackCardPrices(grade) {
    var variants = window.FH_VARIANTS || [];
    packCards.forEach(function (card) {
      var packSize = card.dataset.packSize;
      var count    = parseInt(card.dataset.ballCount, 10);
      var matchV   = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === packSize && variants[i].option2 === grade) {
          matchV = variants[i]; break;
        }
      }
      if (!matchV) return;
      var priceSpan = card.querySelector('.fh-pack__price');
      var perSpan   = card.querySelector('.fh-pack__per');
      var freeSpan  = card.querySelector('.fh-pack__free');
      if (priceSpan) priceSpan.textContent = formatMoney(matchV.price);
      if (perSpan)   perSpan.textContent   = formatMoney(Math.round(matchV.price / count)) + '/ball';
      if (freeSpan)  freeSpan.style.display = matchV.price >= THRESHOLD ? '' : 'none';
    });
  }

  /* ── Pack card click ────────────────────────────────────────── */
  packCards.forEach(function (card) {
    card.addEventListener('click', function () {
      selectedPackSize = card.dataset.packSize;
      packCards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');

      if (selectedGrade) {
        var v = findVariant(selectedPackSize, selectedGrade);
        applyVariant(v, selectedPackSize, selectedGrade);
      }
    });
  });

  /* ── Grade button click ─────────────────────────────────────── */
  gradeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectedGrade = btn.dataset.grade;
      gradeBtns.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');

      updatePackCardPrices(selectedGrade);

      if (selectedPackSize) {
        var v = findVariant(selectedPackSize, selectedGrade);
        applyVariant(v, selectedPackSize, selectedGrade);
      }
    });
  });

  /* ── Quantity selector buttons ──────────────────────────────── */
  document.querySelectorAll('[data-fh-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var current = parseInt(qtyInput.value, 10) || 1;
      var delta   = parseInt(btn.dataset.fhQty, 10);
      var next    = Math.max(1, current + delta);
      qtyInput.value = next;
    });
  });

  /* ── Init from currently selected variant ───────────────────── */
  (function init() {
    var activeCard  = document.querySelector('.fh-pack.is-selected');
    var activeGrade = document.querySelector('.fh-grade-btn.is-selected');
    if (activeCard)  selectedPackSize = activeCard.dataset.packSize;
    if (activeGrade) selectedGrade    = activeGrade.dataset.grade;

    /* Sync shipping bar + availability on load */
    if (window.FH_VARIANTS && selectedPackSize && selectedGrade) {
      var v = findVariant(selectedPackSize, selectedGrade);
      if (v) updateShipping(v.price);
      updateAvailability(selectedPackSize, selectedGrade);
    }
  })();

  /* ── Sticky ATC ─────────────────────────────────────────────── */
  var mainAtcBtn = document.querySelector('[data-fh-atc]');
  if (mainAtcBtn && stickyEl && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting;
      stickyEl.classList.toggle('is-visible', visible);
      stickyEl.setAttribute('aria-hidden', String(!visible));
    }, { threshold: 0 }).observe(mainAtcBtn);
  }

  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  /* ── Gallery ────────────────────────────────────────────────── */
  function setActiveSlide(index) {
    galleryDots.forEach(function (d, i)  { d.classList.toggle('is-active', i === index); });
    galleryThumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
  }

  function goToSlide(index) {
    if (!galleryTrack) return;
    var slide = galleryTrack.children[index];
    if (!slide) return;
    galleryTrack.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    setActiveSlide(index);
  }

  galleryDots.forEach(function (dot) {
    dot.addEventListener('click', function () { goToSlide(parseInt(this.dataset.index, 10)); });
  });
  galleryThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () { goToSlide(parseInt(this.dataset.index, 10)); });
  });

  if (galleryTrack) {
    var scrollTimer;
    galleryTrack.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var index = Math.round(galleryTrack.scrollLeft / (galleryTrack.clientWidth || 1));
        setActiveSlide(index);
      }, 80);
    }, { passive: true });
  }

  /* ── Thumbnail sidebar nav (desktop) ────────────────────────── */
  var thumbNavUp    = document.getElementById('fh-thumb-up');
  var thumbNavDown  = document.getElementById('fh-thumb-down');
  var thumbStrip    = document.getElementById('fh-gallery-thumbs');
  var thumbOffset   = 0;
  var THUMB_STEP    = 66; /* 60px thumb + 6px gap */
  var THUMB_VISIBLE = 5;

  function updateThumbNav() {
    if (!thumbStrip) return;
    thumbStrip.style.transform = 'translateY(-' + (thumbOffset * THUMB_STEP) + 'px)';
    var total = document.querySelectorAll('.fh-gallery__thumb').length;
    if (thumbNavUp)   thumbNavUp.style.visibility   = thumbOffset > 0 ? 'visible' : 'hidden';
    if (thumbNavDown) thumbNavDown.style.visibility = thumbOffset < total - THUMB_VISIBLE ? 'visible' : 'hidden';
  }

  if (thumbNavUp) {
    thumbNavUp.addEventListener('click', function () {
      if (thumbOffset > 0) { thumbOffset--; updateThumbNav(); }
    });
  }
  if (thumbNavDown) {
    thumbNavDown.addEventListener('click', function () {
      var total = document.querySelectorAll('.fh-gallery__thumb').length;
      if (thumbOffset < total - THUMB_VISIBLE) { thumbOffset++; updateThumbNav(); }
    });
  }
  updateThumbNav();

})();
